export default __webpack_public_path__ + "static/media/001.2321713f.webp";